import PhoneFlagInput from './PhoneFlagInput';

export { default as PhoneFlagDisplay } from './PhoneFlagDisplay';

export default PhoneFlagInput;
